import {ManualReviewInsights} from "../../resources/application"

export const parseManualReview = (response: ManualReviewInsights) => {
	const {recommendation, applicationSummary: summary, reason} = response.attributes

	const reasons = reason
		.split("\n")
		.map((line) => line.replace(/^•\s*/, "").trim())
		.filter((line) => line.length > 0)

	return {recommendation, summary, reasons}
}
